module.exports = [
	{
		"age": "16",
		"perUnit": "4.21"
	},
	{
		"age": "17",
		"perUnit": "4.29"
	},
	{
		"age": "18",
		"perUnit": "4.34"
	},
	{
		"age": "19",
		"perUnit": "4.44"
	},
	{
		"age": "20",
		"perUnit": "4.62"
	},
	{
		"age": "21",
		"perUnit": "4.68"
	},
	{
		"age": "22",
		"perUnit": "4.87"
	},
	{
		"age": "23",
		"perUnit": "5.07"
	},
	{
		"age": "24",
		"perUnit": "5.32"
	},
	{
		"age": "25",
		"perUnit": "5.58"
	},
	{
		"age": "26",
		"perUnit": "5.87"
	},
	{
		"age": "27",
		"perUnit": "6.14"
	},
	{
		"age": "28",
		"perUnit": "6.47"
	},
	{
		"age": "29",
		"perUnit": "6.84"
	},
	{
		"age": "30",
		"perUnit": "7.1"
	},
	{
		"age": "31",
		"perUnit": "7.72"
	},
	{
		"age": "32",
		"perUnit": "8.3"
	},
	{
		"age": "33",
		"perUnit": "8.91"
	},
	{
		"age": "34",
		"perUnit": "9.59"
	},
	{
		"age": "35",
		"perUnit": "10.26"
	},
	{
		"age": "36",
		"perUnit": "10.84"
	},
	{
		"age": "37",
		"perUnit": "11.39"
	},
	{
		"age": "38",
		"perUnit": "12.09"
	},
	{
		"age": "39",
		"perUnit": "12.62"
	},
	{
		"age": "40",
		"perUnit": "13.22"
	},
	{
		"age": "41",
		"perUnit": "13.75"
	},
	{
		"age": "42",
		"perUnit": "14.4"
	},
	{
		"age": "43",
		"perUnit": "15.12"
	},
	{
		"age": "44",
		"perUnit": "15.82"
	},
	{
		"age": "45",
		"perUnit": "16.54"
	},
	{
		"age": "46",
		"perUnit": "17.51"
	},
	{
		"age": "47",
		"perUnit": "18.36"
	},
	{
		"age": "48",
		"perUnit": "18.94"
	},
	{
		"age": "49",
		"perUnit": "19.68"
	},
	{
		"age": "50",
		"perUnit": "20.5"
	},
	{
		"age": "51",
		"perUnit": "21.75"
	},
	{
		"age": "52",
		"perUnit": "22.76"
	},
	{
		"age": "53",
		"perUnit": "24.11"
	},
	{
		"age": "54",
		"perUnit": "25.83"
	},
	{
		"age": "55",
		"perUnit": "27.37"
	},
	{
		"age": "56",
		"perUnit": "28.68"
	},
	{
		"age": "57",
		"perUnit": "30.86"
	},
	{
		"age": "58",
		"perUnit": "23.43"
	},
	{
		"age": "59",
		"perUnit": "2.98"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/Git/qsuper-fed/~/json-loader!./src/data/highRiskRateUnitisedPolice.json
// module id = 451
// module chunks = 0